import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/solid';
import { Fragment } from 'react';
import { useStoreMetrics } from './useStoreMetrics';

export const DateRangeSelection = () => {
  const { dateRangeOptions, selectedDateRange, handleSetSelectDateRange } =
    useStoreMetrics();

  return (
    <Listbox
      value={selectedDateRange.label}
      onChange={(value) => {
        handleSetSelectDateRange(
          dateRangeOptions.find((option) => option.label === value)!
        );
      }}
    >
      <div className="relative">
        <Listbox.Button className="relative w-full py-2 pl-3 pr-8 text-left cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm">
          <span className="block font-bold truncate text-segments-link">
            {selectedDateRange.label}
          </span>
          <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
            <ChevronDownIcon
              className="w-5 h-5 text-gray-400"
              aria-hidden="true"
            />
          </span>
        </Listbox.Button>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute z-20 py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg w-44 max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm scrollbar-thin scrollbar-thumb-gray-600 scrollbar-thumb-rounded-full">
            {dateRangeOptions.map((option) => (
              <Listbox.Option
                key={option.label}
                className={({ active }) =>
                  `${active ? 'bg-gray-100' : 'text-gray-900'}
                          cursor-pointer select-none relative py-2 pl-10 pr-4`
                }
                value={option.label}
              >
                {({ selected, active }) => (
                  <>
                    <span
                      className={`${
                        selected
                          ? 'font-bold text-segments-link'
                          : 'font-normal'
                      } block truncate`}
                    >
                      {option.label}
                    </span>
                    {selected ? (
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-segments-link ">
                        <CheckIcon className="w-5 h-5" aria-hidden="true" />
                      </span>
                    ) : null}
                  </>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
};
